import PrivyCode from "../assets/projects/PrivyCode.png";
import EzWait from "../assets/projects/EZWait.png";
import MyChatCV from "../assets/projects/MyChatCV.png";
import KnowNaija from "../assets/projects/KnowNaija.png";
import GospelNoteAI from "../assets/projects/GospelNoteAI.png";
import AccurateA from "../assets/projects/AccurateA.png";

export const data = [
  {
    screenshot: AccurateA,
    projectName: "AccurateA",
    liveDemo: "https://www.accuratea.com/",
    description:
      "An AI-powered accounting automation platform built for UK small businesses and accounting practices. AccurateA automates accounting workflows, including bank reconciliation, invoice processing, and financial reporting, using advanced AI algorithms to enhance accuracy and efficiency.",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/AccurateA",
    stack: ["Python", "Fast API", "React Native", "PostgreSQL", "Open AI API"],
    date: "02/2026 - Present",
  },
  {
    screenshot: GospelNoteAI,
    projectName: "Gospel Note AI",
    liveDemo: "https://apps.apple.com/app/gospel-note-ai/id6749787609",
    description:
      "Gospel Note AI is a mobile app that allows users to record sermons, automatically transcribe them, generate summaries, and extract Bible references using AI. Sermons are saved both locally and on the server for easy access and offline availability.",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/GospelNoteAI",
    stack: ["Python", "Fast API", "React Native", "PostgreSQL", "Open AI API"],
    date: "07/2025 - 08/2025",
  },

  {
    screenshot: PrivyCode,
    projectName: "PrivyCode Website",
    description:
      "PrivyCode is a secure platform that allows developers to share read-only access to their private GitHub repositories with recruiters or collaborators - without making them public or exposing secrets.",
    liveDemo: "https://www.privycode.com/",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/privycode-server",
    frontend: "https://github.com/greatdaveo/privycode-viewer",
    stack: ["Go", "React", "TypeScript", "PostgreSQL"],
    date: "05/2024 - 6/2025",
  },

  {
    screenshot: MyChatCV,
    projectName: "My Chat CV",
    liveDemo: "www.mychatcv.com",
    description:
      "MyChatCV is an AI-powered CV bot that works via WhatsApp. Users send their details, and the bot uses GPT-4 to generate a professional CV, formatted as PDF and Word, with download links sent back instantly.",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/MyChatCV",
    stack: ["Python", "Fast API", "React", "TypeScript", "Twillio"],
    date: "05/2025 - 08/2025",
  },

  {
    screenshot: EzWait,
    projectName: "EZWait Mobile App",
    description:
      "EZWait is a mobile-first waitlist and appointment management system built for service providers such as barbers, hair stylist, salons, and similar service-based businesses. ",
    liveDemo: "https://github.com/greatdaveo/EzWait-Server",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/EzWait-Server",
    // frontend: "https://github.com/greatdaveo/EZWait",
    stack: ["Go", "React Native", "TypeScript", "PostgreSQL"],
    date: "11/2024 - 05/2025",
  },

  {
    // screenshot: MyChatCV,
    projectName: "ML Labs",
    // liveDemo: "this is an api deployed on render",
    description:
      "A hands-on repository where I document and keep track of my learning process in Machine Learning (ML), Deep Learning (DL), and Natural Language Processing (NLP). This repo includes all the practical exercises, code notebooks, and projects tackled throughout my learning journey.",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/ML-Labs",
    stack: ["Jupyter", "Python", "Scikit - Learn", "TensorFlow", "PyTorch"],
    date: "06/2024 - present",
  },

  {
    projectName: "MusicWave API",
    liveDemo: "this is an api deployed on render",
    description:
      "MusicWave API powers a dynamic music streaming experience. It supports user and artiste accounts, song uploads, playlist management, user engagement (likes, follows), and personalized music discovery.",
    // videoDemo: "#",
    backend: "https://github.com/greatdaveo/MusicWave",
    stack: ["Node JS", "TypeScript", "MongoDB"],
    date: "10/2024 - 12/2024",
  },

  {
    screenshot: KnowNaija,
    projectName: "Know Naija",
    liveDemo: "https://github.com/greatdaveo/Know-Naija",
    description: "An App that shows the current affairs in Nigeria.",
    // videoDemo: "#",
    frontend: "https://github.com/greatdaveo/Know-Naija",
    backend: "https://github.com/greatdaveo/Nigeria-Current-Affairs-Api",
    stack: ["React Native", "TypeScript", "MongoDB"],
    date: "07/2024 - 08/2024",
  },
];
